var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiFavorites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.206 2.505A2 2 0 002.6 5.928l.003.003 3.399 3.365 3.398-3.365.032-.03A2 2 0 106.4 3.303a.5.5 0 01-.802-.002 2 2 0 00-1.393-.796zm5.862 4.17l-3.716 3.68a.5.5 0 01-.703 0L1.9 6.643a3 3 0 014.103-4.377 3 3 0 014.065 4.41z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--favorites-19e79330c1e119a762ce71ca56c44977.svg";
export { SvgIconUiFavorites as Component };